module.exports = __webpack_public_path__ + "./assets/modal_qr_desktop_event__c946ea3978c43a2daacee950bdbe3f53.png";